<template>
  <div class="link-input-container">
    <span v-if="label" class="link-input-label">{{ label }}</span>
    <div class="link-input" @click="selectLink">
      <vue-feather type="link-2" size="18" class="link-input-icon" />
      <span v-if="link" ref="linkText" class="link-input-text">{{ link }}</span>
      <span v-else class="link-input-placeholder">{{ placeholder }}</span>
    </div>
  </div>
</template>

<script>
import VueFeather from 'vue-feather'

// A shareable link (waiting room, office portal): clicking anywhere on it selects the
// whole link, ready to copy
export default {
  name: 'LinkInput',
  components: {
    'vue-feather': VueFeather
  },
  props: {
    link: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    // Shown while the link is still loading
    placeholder: {
      type: String,
      default: ''
    }
  },
  methods: {
    selectLink() {
      if (!this.link) return
      const range = document.createRange()
      range.selectNodeContents(this.$refs.linkText)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
    }
  }
}
</script>

<style scoped>
.link-input-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.link-input-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}

.link-input {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-height: 45px;
  padding: 0 0.875rem;
  background: #FFF;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.15s;
}

.link-input:hover {
  border-color: #9ca3af;
}

.link-input-icon {
  color: #9ca3af;
  flex-shrink: 0;
}

.link-input-text,
.link-input-placeholder {
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-input-text {
  color: #4f46e5;
}

.link-input-placeholder {
  color: #9ca3af;
}
</style>
